import { render, staticRenderFns } from "./tongueIconFragmented.vue?vue&type=template&id=303f0619&scoped=true&"
var script = {}
import style0 from "./tongueIconFragmented.vue?vue&type=style&index=0&id=303f0619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303f0619",
  null
  
)

export default component.exports